import styled from "styled-components";

export const StyledStickyHeader = styled.div`
    position: fixed;
    left: 380px;  /* Sidebar width on desktop */
    width: calc(100% - 380px);
    top: 0;
    z-index: 1000;
    background-color: white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        left: 0;
        width: 100%;
    }
`;

export const DateTimeRow = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
`;

export const DateTimeInputWrapper = styled.div<{ hide?: boolean }>`
    flex: 1;
    min-width: 0;
    display: ${(p) => (p.hide ? "none" : undefined)};
`;

export const DateTimeInput = styled.input`
    width: 100%;
    padding: 1rem;
    border-radius: 2rem;
    border: 1px solid #aaa;
    background-color: #f5f5f5;
    box-sizing: border-box;

    @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        padding: 1rem 0;
    }
`;

export const RepeatingFrequencyWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const RepeatingGridContainer = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    gap: 1rem;
    padding-bottom: 1rem;
`;

export const EndMethodContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        gap: 3rem;
    }
`;

export const EndMethodLabel = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    cursor: pointer;

    input[type="radio"] {
        margin: 0;
    }

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        flex-direction: row;
        gap: 8px;
    }
`;

export const EndMethodNumberInput = styled.input`
    width: 6rem;
    height: 4rem;
    padding: 0.5rem;
    border-radius: 5rem;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    box-sizing: border-box;

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        width: 6rem;
        padding: 1rem;
    }
`;

export const EndMethodDateInput = styled.input`
    width: 12rem;
    height: 4rem;
    padding: 0.5rem;
    border-radius: 5rem;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    box-sizing: border-box;

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        width: 14rem;
        padding: 1rem;
    }
`;

export const ExecutionDateContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        gap: 3rem;
    }
`;

export const ExecutionDateLabel = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    cursor: pointer;

    input[type="radio"] {
        margin: 0;
    }

    .label-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        flex-direction: row;
        gap: 8px;

        .label-text {
            flex-direction: row;
            gap: 4px;
        }
    }
`;

export const ExecutionDateOption = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    input[type="radio"] {
        margin: 0;
        cursor: pointer;
    }

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        flex-direction: row;
        gap: 8px;
    }
`;

export const ExecutionDateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #ccc;
    margin-bottom: 1rem;
`;

export const DaysOfWeekContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-start;
    gap: 1px;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    border: 1px solid #000;
    border-radius: 1rem;
    padding: 0;
    overflow: hidden;
    background-color: #000;
    width: 100%;

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        width: auto;
    }
`;

export const DayToggleButton = styled.span<{ selected: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 0.5rem;
    background-color: ${(p) => (p.selected ? "#000" : "#fff")};
    color: ${(p) => (p.selected ? "#fff" : "#000")};
    cursor: pointer;
    user-select: none;
    flex: 1;

    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        padding: 1rem 2rem;
        flex: initial;
    }
`;
